var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.995 0.5C2.235 0.5 0 2.74 0 5.5C0 8.26 2.235 10.5 4.995 10.5C7.76 10.5 10 8.26 10 5.5C10 2.74 7.76 0.5 4.995 0.5ZM3.25 3.5C3.665 3.5 4 3.835 4 4.25C4 4.665 3.665 5 3.25 5C2.835 5 2.5 4.665 2.5 4.25C2.5 3.835 2.835 3.5 3.25 3.5ZM7.355 6.86C6.9 7.835 6.02 8.5 5 8.5C3.98 8.5 3.1 7.835 2.645 6.86C2.565 6.695 2.685 6.5 2.87 6.5H7.13C7.315 6.5 7.435 6.695 7.355 6.86ZM6.75 5C6.335 5 6 4.665 6 4.25C6 3.835 6.335 3.5 6.75 3.5C7.165 3.5 7.5 3.835 7.5 4.25C7.5 4.665 7.165 5 6.75 5Z",
    fill: "#A3AED0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceLight);
export default __webpack_public_path__ + "static/media/face_light.1212982a446c0eb2dd2c0e4dcdb579d8.svg";
export { ForwardRef as ReactComponent };